/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ minutes: NonNullable<unknown> }} Notifications_Time_Minutes_AgoInputs */

const en_notifications_time_minutes_ago = /** @type {(inputs: Notifications_Time_Minutes_AgoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.minutes}m ago`)
};

const pl_notifications_time_minutes_ago = /** @type {(inputs: Notifications_Time_Minutes_AgoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.minutes} min temu`)
};

/**
* | output |
* | --- |
* | "{minutes}m ago" |
*
* @param {Notifications_Time_Minutes_AgoInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const notifications_time_minutes_ago = /** @type {((inputs: Notifications_Time_Minutes_AgoInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Time_Minutes_AgoInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_notifications_time_minutes_ago(inputs)
	return en_notifications_time_minutes_ago(inputs)
});